/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareRoot = createReactComponent("outline", "square-root", "IconSquareRoot", [["path", { "d": "M3 12h2l4 8l4 -16h8", "key": "svg-0" }]]);

export { IconSquareRoot as default };
//# sourceMappingURL=IconSquareRoot.mjs.map
